import { Tooltip } from "@/shared/ui";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Switch, Text } from "@tremor/react";
interface PresetControlsProps {
  isPrivate: boolean;
  setIsPrivate: (value: boolean) => void;
  isNoisy: boolean;
  setIsNoisy: (value: boolean) => void;
  counterShowsFiringOnly: boolean;
  setCounterShowsFiringOnly: (value: boolean) => void;
}
export const PresetControls: React.FC<PresetControlsProps> = ({
  isPrivate,
  setIsPrivate,
  isNoisy,
  setIsNoisy,
  counterShowsFiringOnly,
  setCounterShowsFiringOnly
}) => {
  return <div className="mt-4" data-sentry-component="PresetControls" data-sentry-source-file="preset-controls.tsx">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <Switch id="private" checked={isPrivate} onChange={() => setIsPrivate(!isPrivate)} color="orange" data-sentry-element="Switch" data-sentry-source-file="preset-controls.tsx" />
          <label htmlFor="private" className="text-sm text-gray-500">
            <Text data-sentry-element="Text" data-sentry-source-file="preset-controls.tsx">Private</Text>
          </label>
          <Tooltip content={<>Private presets are only visible to you</>} className="z-60" data-sentry-element="Tooltip" data-sentry-source-file="preset-controls.tsx">
            <InformationCircleIcon className="w-4 h-4" data-sentry-element="InformationCircleIcon" data-sentry-source-file="preset-controls.tsx" />
          </Tooltip>
        </div>

        <div className="flex items-center gap-2">
          <Switch data-testid="is-noisy-switch" id="noisy" checked={isNoisy} onChange={() => setIsNoisy(!isNoisy)} color="orange" data-sentry-element="Switch" data-sentry-source-file="preset-controls.tsx" />
          <label htmlFor="noisy" className="text-sm text-gray-500">
            <Text data-sentry-element="Text" data-sentry-source-file="preset-controls.tsx">Noisy</Text>
          </label>
          <Tooltip content={<>Noisy presets will trigger sound for every matching event</>} className="z-60" data-sentry-element="Tooltip" data-sentry-source-file="preset-controls.tsx">
            <InformationCircleIcon className="w-4 h-4" data-sentry-element="InformationCircleIcon" data-sentry-source-file="preset-controls.tsx" />
          </Tooltip>
        </div>
        <div className="flex items-center gap-2">
          <Switch data-testid="counter-shows-firing-only-switch" id="counterShowsFiringOnly" checked={counterShowsFiringOnly} onChange={() => setCounterShowsFiringOnly(!counterShowsFiringOnly)} color="orange" data-sentry-element="Switch" data-sentry-source-file="preset-controls.tsx" />
          <label htmlFor="counterShowsFiringOnly" className="text-sm text-gray-500">
            <Text data-sentry-element="Text" data-sentry-source-file="preset-controls.tsx">Firing alerts counter mode</Text>
          </label>
          <Tooltip content={<>
                Indicates whether the counter in the navbar shows only firing
                alerts or all matching alerts for this preset
              </>} className="z-60" data-sentry-element="Tooltip" data-sentry-source-file="preset-controls.tsx">
            <InformationCircleIcon className="w-4 h-4" data-sentry-element="InformationCircleIcon" data-sentry-source-file="preset-controls.tsx" />
          </Tooltip>
        </div>
      </div>
    </div>;
};